import React, { useState, useContext } from 'react'
import ShoppingBagSVG from '../../shared/icons/ShoppingBagSVG'
import Spinner from '../../shared/components/Spinner'
import { SwiperSlide } from 'swiper/react'
import { find, isNil, map, pathOr } from 'ramda'
import DealmedDialog from '../../shared/components/DealmedDialog'
import AddToItemListDropdown from '../ItemList/AddToItemListDropdown'
import CloseSVG from '../../shared/icons/CloseSVG'
import CheckmarkSVG from '../../shared/icons/CheckmarkSVG'
import ErrorSVG from '../../shared/icons/ErrorSVG'
import TransactionHOC from '../Reusable/TransactionHOC'
import './SingleProduct.scss'
import { mixpanelLogEvent } from '../../utils/mixpanelLogEvent'
import CartHOC from '../Reusable/CartHOC'
import { ShoppingContext } from '../../shared/ShoppingContext'
import aa from 'search-insights'

const { REACT_APP_STORAGE_URL, REACT_APP_CONT_PRODUCT_IMG, PUBLIC_URL } = process.env

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

function ItemCarouselCard({
  item,
  isAuthenticated,
  isPriceVisible,
  validateRxAndAddToCart,
  showStockStatus,
  validateRx,
  cartDetail,
}) {
  const [isAddingToCart, setIsAddingToCart] = useState(false)
  const [showDialog, setShowDialog] = useState(false)
  const [matrixItemDetails, setMatrixItemDetails] = useState(
    item?.children?.length > 0
      ? {
          id: item.children[0].id,
          itemName: item.children[0].itemName,
          matrixDetails: item.children[0].matrixDetails,
          mpn: item.children[0].mpn,
          price: item.children[0].price,
          quantityAvailable: item.children[0].quantityAvailable,
          // rxLevel: item.children[0].rxLevel,
          urlComponent: item.children[0].urlComponent,
        }
      : '',
  )

  let productPrice = formatter.format(item?.price)

  const { userInfo } = useContext(ShoppingContext)

  const openDialog = () => {
    setShowDialog(true)
  }

  const closeDialog = () => {
    setShowDialog(false)
  }

  const logClickEvent = ({ eventType }) => {
    mixpanelLogEvent({
      eventType,
      userDetails: userInfo,
      itemDetails: item,
      metaData: {
        cartDetails: cartDetail,
      },
    })
  }

  const addProductToCart = async () => {
    setIsAddingToCart(true)
    await validateRxAndAddToCart(
      matrixItemDetails.id ? { id: matrixItemDetails.id } : { id: item.id },
      1,
      null,
    )
    logClickEvent({ eventType: 'PDP_Carousel_Add_Item_To_Cart' })
    if (process.env.NODE_ENV !== 'production') {
      aa('addedToCartObjectIDs', {
        eventName: 'PDP Carousel Added to Cart',
        index: 'itemsIndex',
        objectIDs: [String(item?.id)],
      })
    }
    setIsAddingToCart(false)
  }

  const isAddableToCart = item.isAddableToCart
  const { isValidRxLevel, isSellableCSL } = validateRx({ rxLevel: item?.rxLevel })

  const isUnavailable = item?.price == 'N/A' || matrixItemDetails?.price == 'N/A'
  const hiddenPriceBool = isUnavailable || (!isAddableToCart && !isNil(isAddableToCart))

  const onItemClick = () => {
    if (process.env.NODE_ENV !== 'production') {
      aa('clickedObjectIDs', {
        eventName: 'PDP Carousel Item Click',
        index: 'itemsIndex',
        objectIDs: [String(item?.id)],
      })
    }
  }

  const AddToCartButton = () => {
    return (
      <button
        type="button"
        className="dealmed-product__add-to-cart"
        disabled={(isUnavailable && isAuthenticated) || (isAddingToCart && true)}
        onClick={addProductToCart}
        style={isUnavailable && isAuthenticated ? { backgroundColor: '#384349' } : {}}
      >
        {isAddingToCart ? (
          <Spinner />
        ) : (
          <>
            <img
              className="productDetails__featured-products-box-buttons-addtocart-icon"
              src={`${PUBLIC_URL}/images/shopping-bag.png`}
              alt=""
              loading="lazy"
            />
            <span
              className="productDetails__featured-products-box-buttons-addtocart-title"
              style={{ fontSize: '10px !important' }}
            >
              {isUnavailable && isAuthenticated ? 'Currently Unavailable' : 'Add to cart'}
            </span>
          </>
        )}
      </button>
    )
  }

  return (
    <SwiperSlide className="productDetails__featured-products-box">
      <a href={`/product/${item?.urlComponent}`} onClick={onItemClick}>
        <div className="productDetails__featured-products-box-top">
          <div className="carousel-image-container">
            <div className="productDetails__featured-products-box-image">
              <img
                src={item.thumbnailImage || item.largeUrl}
                alt={item.siteDisplayName || item.displayName}
                loading="lazy"
              />
            </div>
          </div>
          <div
            className="productDetails__featured-products-box-texts"
            style={{ padding: '0 12px' }}
          >
            <p className="productDetails__featured-products-box-manufacturer">
              {item.manufacturer}
            </p>
            <h4 className="productDetails__featured-products-box-name">
              {item.siteDisplayName || item.displayName}
            </h4>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0 12px' }}>
            {isPriceVisible && item?.price !== 'N/A' && (
              <div className="productDetails__featured-products-box-price">
                <p className="productDetails__featured-products-box-price-text">{productPrice}</p>
              </div>
            )}
            {showStockStatus && (
              <div>
                {item.quantityAvailable > 0 ? (
                  <div className="product-details__availability" style={{ display: 'flex' }}>
                    {/* <span className="product-details__availability-icon-wrapper">
							<CheckmarkSVG className="product-details__availability-icon product-details__availability-icon--available" />
						</span>
						<p className="product-details__availability-text product-details__availability-text--available">In Stock</p> */}
                  </div>
                ) : (
                  <div
                    style={{
                      fontSize: '12px',
                      color: '#9B9191',
                      backgroundColor: '#F7F7F7',
                      padding: '8px 16px',
                      fontWeight: '600',
                    }}
                  >
                    {/* <span className="product-details__availability-icon-wrapper">
              <ErrorSVG className="product-details__availability-icon product-details__availability-icon--unavailable" />
            </span> */}
                    <span>Out of Stock</span>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </a>
      <div
        className="productDetails__featured-products-box-buttons"
        style={{ padding: '0 12px', display: 'flex', gap: '4px' }}
      >
        {isValidRxLevel && isSellableCSL ? (
          <button
            type="button"
            className="dealmed-product__add-to-cart"
            disabled={(hiddenPriceBool && isAuthenticated) || (isAddingToCart && true)}
            onClick={addProductToCart}
            style={hiddenPriceBool && isAuthenticated ? { backgroundColor: '#384349' } : {}}
          >
            {isAddingToCart ? (
              <Spinner />
            ) : (
              <>
                <span
                  className="quickorder__products-box-buttons-addtocart-title"
                  style={{ fontSize: hiddenPriceBool && isAuthenticated ? '18px' : null }}
                >
                  {hiddenPriceBool && isAuthenticated ? 'Currently Unavailable' : 'Add to cart'}
                </span>
                {/* <span className="dealmed-product__add-to-cart-icon-wrapper">
                      {hiddenPriceBool && isAuthenticated ? null : (
                        <ShoppingBagSVG className="dealmed-product__add-to-cart-icon" />
                      )}
                    </span> */}
              </>
            )}
          </button>
        ) : (
          <p className="dealmed-product__unable">
            This item requires a medical license to purchase
          </p>
        )}
        <div className="productDetails__featured-products-box-buttons-addtolist">
          <div
            className="productDetails__featured-products-box-buttons-addtolist-select"
            tabIndex="0"
            onClick={() => {
              logClickEvent({ eventType: 'PDP_Carousel_Add_Item_To_List' })
              setShowDialog(true)
            }}
          >
            {/* <span className="current">ADD TO LIST</span><ul className="list"><li data-value="ADD TO LIST" className="option selected">ADD TO LIST</li><li data-value="2" className="option">2</li><li data-value="3" className="option">3</li></ul> */}
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M3 16H10V14H3M18 14V10H16V14H12V16H16V20H18V16H22V14M14 6H3V8H14M14 10H3V12H14V10Z"></path>
            </svg>
          </div>
        </div>
      </div>
      <DealmedDialog
        isOpen={showDialog}
        onDismiss={closeDialog}
        className="product-details__action-dialog"
        label="Add to List Dialog"
        style={{ backgroundColor: 'transparent' }}
      >
        <div className="product-details__action-content">
          <button
            className="product-details__action-close"
            onClick={closeDialog}
            aria-label="Close Add To List Dialog"
          >
            <CloseSVG className="product-details__action-icon product-details__action-icon--close" />
          </button>
          <h2 className="product-details__action-header">Add To List</h2>
          {item && <AddToItemListDropdown quantity={1} itemId={item.id} unit={null} />}
        </div>
      </DealmedDialog>
    </SwiperSlide>
  )
}

export default CartHOC(TransactionHOC(ItemCarouselCard))
